export const REFRESH_THRESHOLD = 600; // 10 minutes
export const basicTokenExpirationTime = Math.floor(Date.now() / 1000) + REFRESH_THRESHOLD;